export default "__VITE_ASSET__1d2c8374__"